import React, { useState } from 'react';
import { Card, Form, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import PageHeader1 from '../../components/common/PageHeader1';
import apiClient from "../../utils/api";

function SMSSettingsAdd() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        api_key: '',
        sms_template: '',
        enable_payment_url: false,
        mobile_required: false
    });

    const handleInputChange = (e) => {
        const { name, type, checked, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('auth_token');
            await apiClient.post('accounts/sms-settings', formData,{
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success('SMS setting created successfully');
            navigate('/accounts/sms-settings-list');
        } catch (error) {
            console.error('Error:', error);
            toast.error('Error creating SMS setting');
        }
    };

    return (
        <div className="body d-flex py-3">
            <div className="container-xxl">
                <PageHeader1 pagetitle='Add SMS Setting' />
                <Card>
                    <Card.Body>
                        <Form onSubmit={handleSubmit}>
                            <div className="row g-3">
                                <div className="col-md-12">
                                    <Form.Group>
                                        <Form.Label>SMS Gateway API Key</Form.Label>
                                        <Form.Control
                                            type="password"
                                            name="api_key"
                                            value={formData.api_key}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </Form.Group>
                                </div>
                                <div className="col-12">
                                    <Form.Group>
                                        <Form.Label>Default SMS Template</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={4}
                                            name="sms_template"
                                            value={formData.sms_template}
                                            onChange={handleInputChange}
                                            placeholder="Enter default SMS template text..."
                                            required
                                        />
                                        <Form.Text className="text-muted">
                                            Available variables: {'{ticket_number}'}, {'{amount}'}, {'{payment_url}'}
                                        </Form.Text>
                                    </Form.Group>
                                </div>
                                <div className="col-md-6">
                                    <Form.Group>
                                        <Form.Check
                                            type="switch"
                                            id="enable_payment_url"
                                            name="enable_payment_url"
                                            label="Enable Payment URL in SMS"
                                            checked={formData.enable_payment_url}
                                            onChange={handleInputChange}
                                        />
                                    </Form.Group>
                                </div>
                                <div className="col-md-6">
                                    <Form.Group>
                                        <Form.Check
                                            type="switch"
                                            id="mobile_required"
                                            name="mobile_required"
                                            label="Mobile Number Required"
                                            checked={formData.mobile_required}
                                            onChange={handleInputChange}
                                        />
                                    </Form.Group>
                                </div>
                                <div className="col-12">
                                    <Button type="submit" variant="primary">
                                        Save Settings
                                    </Button>
                                </div>
                            </div>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
}

export default SMSSettingsAdd;